// Add your custom JS here.

window.addEventListener('load', function() {

    var $iframes = jQuery('iframe');

    $iframes.each(function() {
        var $iframe = jQuery(this);
        var parent = $iframe.parent().get(0);
        var tagName = parent.tagName;

        // Check if this is a Spotify iframe
        var iframeSrc = $iframe.attr('src');
        var isSpotify = /spotify.com/.test(iframeSrc);

        if (tagName === 'P') {
            if (!isSpotify) {
                // Add a mk-video-container class
                $iframe.wrap('<div class="video-embed-container"></div>');
            } else {
                // Do not add a mk-video-container class
                $iframe.wrap('<div class="spotify-embed-container"></div>');
            }
        }

    });

});